// Port of api/fuel/app/classes/filter/package/lists/listing.php
import EditionsData from 'offline/filter/package/lists/listing/data/editions'
import GamesData from 'offline/filter/package/lists/listing/data/games'
import PrepareGeneral from 'offline/filter/package/lists/listing/prepare/general'
import GeneralPackage from 'offline/filter/package/lists/listing/package/general'

function sortUnits(units) {
	return units.slice().sort(function(a, b) {
		return (a.priority || 0) - (b.priority || 0)
	})
}

export default {
	data_units: [GamesData, EditionsData],

	run: function(resultId, local, global, config, filter) {
		local.id = resultId
		local = PrepareGeneral.run(local, global, config, filter)
		return GeneralPackage.run({ id: resultId }, local, global, config, filter)
	},

	run_data: function(global, config, filter, data) {
		var units = sortUnits(this.data_units)
		for (var i = 0; i < units.length; i++) {
			var result = units[i].run(filter, data, config, global)
			if (result !== undefined) global = result
		}
		return global
	}
}
